import {
    COR_STATUS_ACEITO,
    COR_STATUS_CANCELADO,
    COR_STATUS_EM_ROTA,
    COR_STATUS_FINALIZADO,
    COR_STATUS_PREPARO,
    COR_STATUS_PRONTO,
} from "../../../utils/coresStatusPedido"

/**
 * Esquema de cores dos marcadores de pedido no mapa da Roteirização, POR STATUS —
 * as mesmas cores das raias do Recebedor de Pedidos (utils/coresStatusPedido.ts):
 * - amarelo:  aceito (0, 1, 2);
 * - laranja:  em preparação (7, 10 e demais positivos);
 * - roxo:     pronto — aguardando entregador / retirada (6);
 * - azul:     em entrega (3);
 * - verde:    entregue/pago (só aparece se o filtro permitir);
 * - vermelho: cancelado (só aparece se o filtro permitir).
 * O pedido selecionado ganha um contorno preto (COR_SELECIONADO), cor que não é de status.
 */
export const COR_ACEITO = COR_STATUS_ACEITO
export const COR_PREPARO = COR_STATUS_PREPARO
export const COR_PRONTO = COR_STATUS_PRONTO
export const COR_EM_ROTA = COR_STATUS_EM_ROTA
export const COR_FINALIZADO = COR_STATUS_FINALIZADO
export const COR_CANCELADO = COR_STATUS_CANCELADO
export const COR_SELECIONADO = "#212121"

/** Status do pedido => cor do marcador. */
export function corDoStatus(status: number): string {
    if (status < 0) return COR_CANCELADO
    if (status === 0 || status === 1 || status === 2) return COR_ACEITO
    if (status === 6) return COR_PRONTO
    if (status === 3) return COR_EM_ROTA
    if (status === 4 || status === 5 || status === 9) return COR_FINALIZADO
    return COR_PREPARO
}

/** Cor do texto sobre o fundo do marcador (escuro no amarelo, para ler no mapa). */
export function corTextoSobre(corFundo: string): string {
    return corFundo === COR_ACEITO ? "#1a1a1a" : "#ffffff"
}
